function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 56px;\n  color: #141617;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 45px;\n  color: #141617;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 34px;\n  color: #141617;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 26px;\n  color: #141617;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  color: #141617;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 29px;\n  color: #141617;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 29px;\n  color: #141617;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #141617;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 26px;\n  color: #141617;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  color: #141617;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  color: #141617;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 26px;\n  color: #141617;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 26px;\n  color: #141617;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 39px;\n  color: #141617;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 34px;\n  color: #141617;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  color: #141617;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 25px;\n  color: #141617;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: #141617;\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 21px;\n  color: #141617;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 21px;\n  color: #141617;\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #141617;\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #141617;\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 15px;\n  color: #141617;\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 24px;\n  color: #141617;\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 15px;\n  line-height: 24px;\n  color: #141617;\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "./chunk-QDWKGFSM.mjs";
import { fontPretendard } from "./chunk-WYJ4VAJ4.mjs";
import { __export } from "./chunk-SPFPWZVF.mjs";
// src/font/font.style.ts
var font_style_exports = {};
__export(font_style_exports, {
    mArticle1: function() {
        return mArticle1;
    },
    mArticle2: function() {
        return mArticle2;
    },
    mBody1: function() {
        return mBody1;
    },
    mBody2: function() {
        return mBody2;
    },
    mBody3: function() {
        return mBody3;
    },
    mBody4: function() {
        return mBody4;
    },
    mCaption1: function() {
        return mCaption1;
    },
    mCaption2: function() {
        return mCaption2;
    },
    mCaption3: function() {
        return mCaption3;
    },
    mHeader0: function() {
        return mHeader0;
    },
    mHeader1: function() {
        return mHeader1;
    },
    mHeader2: function() {
        return mHeader2;
    },
    mTitle1: function() {
        return mTitle1;
    },
    mTitle2: function() {
        return mTitle2;
    },
    mTitle3: function() {
        return mTitle3;
    },
    wArticle1: function() {
        return wArticle1;
    },
    wArticle2: function() {
        return wArticle2;
    },
    wBody1: function() {
        return wBody1;
    },
    wBody2: function() {
        return wBody2;
    },
    wBody3: function() {
        return wBody3;
    },
    wBody4: function() {
        return wBody4;
    },
    wCaption1: function() {
        return wCaption1;
    },
    wCaption2: function() {
        return wCaption2;
    },
    wHeader1: function() {
        return wHeader1;
    },
    wHeader2: function() {
        return wHeader2;
    },
    wTitle1: function() {
        return wTitle1;
    },
    wTitle2: function() {
        return wTitle2;
    },
    wTitle3: function() {
        return wTitle3;
    },
    wTitle4: function() {
        return wTitle4;
    },
    wTitle5: function() {
        return wTitle5;
    }
});
var wHeader1 = css(_templateObject(), fontPretendard);
var wHeader2 = css(_templateObject1(), fontPretendard);
var wTitle1 = css(_templateObject2(), fontPretendard);
var wTitle2 = css(_templateObject3(), fontPretendard);
var wTitle3 = css(_templateObject4(), fontPretendard);
var wTitle4 = css(_templateObject5(), fontPretendard);
var wTitle5 = css(_templateObject6(), fontPretendard);
var wBody1 = css(_templateObject7(), fontPretendard);
var wBody2 = css(_templateObject8(), fontPretendard);
var wBody3 = css(_templateObject9(), fontPretendard);
var wBody4 = css(_templateObject10(), fontPretendard);
var wCaption1 = css(_templateObject11(), fontPretendard);
var wCaption2 = css(_templateObject12(), fontPretendard);
var wArticle1 = css(_templateObject13(), fontPretendard);
var wArticle2 = css(_templateObject14(), fontPretendard);
var mHeader0 = css(_templateObject15(), fontPretendard);
var mHeader1 = css(_templateObject16(), fontPretendard);
var mHeader2 = css(_templateObject17(), fontPretendard);
var mTitle1 = css(_templateObject18(), fontPretendard);
var mTitle2 = css(_templateObject19(), fontPretendard);
var mTitle3 = css(_templateObject20(), fontPretendard);
var mBody1 = css(_templateObject21(), fontPretendard);
var mBody2 = css(_templateObject22(), fontPretendard);
var mBody3 = css(_templateObject23(), fontPretendard);
var mBody4 = css(_templateObject24(), fontPretendard);
var mCaption1 = css(_templateObject25(), fontPretendard);
var mCaption2 = css(_templateObject26(), fontPretendard);
var mCaption3 = css(_templateObject27(), fontPretendard);
var mArticle1 = css(_templateObject28(), fontPretendard);
var mArticle2 = css(_templateObject29(), fontPretendard);
export { wHeader1, wHeader2, wTitle1, wTitle2, wTitle3, wTitle4, wTitle5, wBody1, wBody2, wBody3, wBody4, wCaption1, wCaption2, wArticle1, wArticle2, mHeader0, mHeader1, mHeader2, mTitle1, mTitle2, mTitle3, mBody1, mBody2, mBody3, mBody4, mCaption1, mCaption2, mCaption3, mArticle1, mArticle2, font_style_exports };
